/* ==========================================================================
   La Papasada — Product Wizard JS
   4-step customization: Base → Toppings → Extras → Summary → Checkout
   ========================================================================== */

(function() {
  'use strict';

  var wizard = document.querySelector('[data-wizard]');
  if (!wizard) return;

  var currentStep = 0;
  var totalSteps = 4;
  var selectedBase = null;
  var selectedItems = {}; // { id: { name, price, qty, type, variantId } }
  var wizardMode = 'locked';
  var addressLookupTimer = null;
  var selectedAddressSuggestion = null;

  var steps = wizard.querySelectorAll('[data-wizard-step]');
  var dots = wizard.querySelectorAll('[data-wizard-dot]');
  var lines = wizard.querySelectorAll('[data-wizard-line]');
  var totalEl = wizard.querySelector('[data-wizard-total]');
  var continueBtn = wizard.querySelector('[data-wizard-continue]');
  var backBtn = wizard.querySelector('[data-wizard-back]');
  var summaryContainer = wizard.querySelector('[data-wizard-summary]');
  var step2Title = wizard.querySelector('[data-wizard-step2-title]');
  var step2Subtitle = wizard.querySelector('[data-wizard-step2-subtitle]');
  var step2BaseSummary = wizard.querySelector('[data-wizard-base-summary]');
  var step2BaseSummaryTitle = wizard.querySelector('[data-wizard-base-summary-title]');
  var step2BaseSummaryDescription = wizard.querySelector('[data-wizard-base-summary-description]');
  var experience = wizard.querySelector('[data-wizard-experience]');
  var gate = wizard.querySelector('[data-wizard-gate]');
  var addressForm = wizard.querySelector('[data-wizard-address-form]');
  var addressInput = wizard.querySelector('[data-wizard-address-input]');
  var postalInput = wizard.querySelector('[data-wizard-postal-input]');
  var cityInput = wizard.querySelector('[data-wizard-city-input]');
  var suggestionsEl = wizard.querySelector('[data-wizard-address-suggestions]');
  var addressLoadingEl = wizard.querySelector('[data-wizard-address-loading]');
  var addressSubmitBtn = wizard.querySelector('[data-wizard-address-submit]');
  var locateAddressBtn = wizard.querySelector('[data-wizard-address-locate]');
  var gateResult = wizard.querySelector('[data-wizard-gate-result]');
  var gateStatus = wizard.querySelector('[data-wizard-gate-status]');
  var gateDetail = wizard.querySelector('[data-wizard-gate-detail]');
  var gateActions = wizard.querySelector('[data-wizard-gate-actions]');
  var deliverySummary = wizard.querySelector('[data-wizard-delivery-summary]');
  var deliverySummaryAddress = wizard.querySelector('[data-wizard-delivery-address]');
  var deliverySummaryStatus = wizard.querySelector('[data-wizard-delivery-status]');
  var changeAddressBtn = wizard.querySelector('[data-wizard-change-address]');
  var upsellModal = wizard.querySelector('[data-wizard-upsell]');
  var lastFocusedElement = null;
  var spiceNames = ['NADA', 'SUAVE', 'MEDIO', 'PICANTE', 'INFERNO'];
  var selectedSpice = 0;

  function formatMoney(cents) {
    return (cents / 100).toFixed(2) + '€';
  }

  function buildBaseProperties() {
    var properties = {
      'Picante': spiceNames[selectedSpice]
    };

    var selectedToppings = Object.keys(selectedItems).map(function(id) {
      return selectedItems[id];
    }).filter(function(item) {
      return item.type === 'topping' && item.qty > 0;
    }).map(function(item) {
      return item.name + ' x' + item.qty;
    });

    if (selectedBase && selectedBase.isCustom) {
      properties['Configuración'] = 'A tu rollo';
      if (selectedToppings.length > 0) {
        properties['Toppings'] = selectedToppings.join(', ');
      }
    }

    return properties;
  }

  function getTotal() {
    var total = 0;
    if (selectedBase) total += selectedBase.price;
    Object.keys(selectedItems).forEach(function(id) {
      var item = selectedItems[id];
      if (item.type === 'topping') {
        // Toppings scale with base quantity (future: baseQuantity variable)
        total += item.price * item.qty;
      } else {
        total += item.price * item.qty;
      }
    });
    return total;
  }

  function hasToppingsSelected() {
    return Object.keys(selectedItems).some(function(id) {
      return selectedItems[id].type === 'topping' && selectedItems[id].qty > 0;
    });
  }

  function getSelectedExtraCount() {
    return Object.keys(selectedItems).reduce(function(total, id) {
      var item = selectedItems[id];
      if (item.type === 'extra' && item.qty > 0) {
        return total + item.qty;
      }
      return total;
    }, 0);
  }

  function getCoverageState() {
    if (!window.themeCoverage || typeof window.themeCoverage.getState !== 'function') return { status: 'unknown' };
    return window.themeCoverage.getState() || { status: 'unknown' };
  }

  function setWizardMode(mode) {
    wizardMode = mode;
    var shouldShowExperience = mode === 'own_delivery' || mode === 'browse_only';
    if (experience) experience.hidden = !shouldShowExperience;
    wizard.classList.toggle('wizard--browse-only', mode === 'browse_only');
  }

  function setGateVisibility(isVisible) {
    if (!gate) return;
    gate.hidden = !isVisible;
  }

  function setSuggestionsLoading(isLoading) {
    if (!addressLoadingEl) return;
    addressLoadingEl.hidden = !isLoading;
  }

  function clearSuggestions() {
    if (!suggestionsEl) return;
    suggestionsEl.hidden = true;
    suggestionsEl.innerHTML = '';
    setSuggestionsLoading(false);
  }

  function renderSuggestions(items) {
    if (!suggestionsEl) return;
    if (!items || !items.length) {
      clearSuggestions();
      return;
    }

    suggestionsEl.innerHTML = items.map(function(item, index) {
      return '<button type="button" class="wizard__suggestion" data-wizard-suggestion="' + index + '">' +
        '<span class="wizard__suggestion-title">' + item.label + '</span>' +
      '</button>';
    }).join('');

    suggestionsEl.hidden = false;
    suggestionsEl._items = items;
  }

  function updateDeliverySummary(state) {
    if (!deliverySummary || !deliverySummaryAddress || !deliverySummaryStatus) return;

    if (!state || !state.status || state.status === 'unknown') {
      deliverySummary.hidden = true;
      return;
    }

    var addressText = state.formatted_address || state.address || '';
    var statusText = '';

    if (state.status === 'own_delivery') {
      statusText = 'Entrega propia disponible';
    } else if (state.status === 'third_party') {
      statusText = 'Solo disponible con ' + (state.provider || 'Glovo');
    } else if (state.status === 'unavailable') {
      statusText = 'Sin delivery para esta dirección';
    } else if (state.status === 'error') {
      statusText = state.message || 'Dirección sin validar';
    } else {
      statusText = 'Comprobando cobertura';
    }

    deliverySummaryAddress.textContent = addressText || 'Dirección de entrega';
    deliverySummaryStatus.textContent = statusText;
    deliverySummary.hidden = false;
  }

  function setGateResult(state) {
    if (!gateResult || !gateStatus || !gateDetail || !gateActions) return;

    var status = state && state.status ? state.status : 'unknown';
    gateResult.className = 'wizard__gate-result wizard__gate-result--' + status;
    gateActions.innerHTML = '';
    updateDeliverySummary(state);

    if (status === 'own_delivery') {
      gateStatus.textContent = 'Perfecto, hacemos delivery en esa dirección';
      gateDetail.textContent = state.formatted_address || state.address || 'Puedes seguir con tu pedido.';
      gateActions.innerHTML = '<button type="button" class="btn btn--primary" data-wizard-gate-proceed>Empezar pedido</button>';
      setWizardMode('own_delivery');
      return;
    }

    if (status === 'third_party') {
      gateStatus.textContent = 'En esa dirección solo llegamos con ' + (state.provider || 'Glovo');
      gateDetail.textContent = 'Puedes pedir con app externa, pasar a recoger o ver la carta sin habilitar checkout.';
      gateActions.innerHTML =
        '<a class="btn btn--primary" href="' + (state.provider_url || '#') + '" target="_blank" rel="noopener">Pedir en ' + (state.provider || 'Glovo') + '</a>' +
        '<a class="btn btn--ghost" href="/#ubicacion">Ver locales</a>' +
        '<button type="button" class="btn btn--outline" data-wizard-gate-browse>Ver carta</button>';
      setWizardMode('locked');
      return;
    }

    if (status === 'unavailable') {
      gateStatus.textContent = 'Ahora mismo no repartimos en esa dirección';
      gateDetail.textContent = 'Puedes revisar nuestros locales o echar un vistazo a la carta sin activar compra.';
      gateActions.innerHTML =
        '<a class="btn btn--primary" href="/#ubicacion">Ver locales</a>' +
        '<button type="button" class="btn btn--outline" data-wizard-gate-browse>Ver carta sin comprar</button>';
      setWizardMode('locked');
      return;
    }

    if (status === 'locating') {
      gateStatus.textContent = 'Comprobando cobertura';
      gateDetail.textContent = 'Estamos validando si esa dirección entra en delivery propio o no.';
      setWizardMode('locked');
      return;
    }

    if (status === 'error') {
      gateStatus.textContent = 'No hemos podido validar esa dirección';
      gateDetail.textContent = state.message || 'Prueba de nuevo con una dirección más completa o usando tu ubicación.';
      setWizardMode('locked');
      return;
    }

    gateStatus.textContent = 'Introduce la dirección de entrega';
    gateDetail.textContent = 'Así evitamos que montes el pedido completo y descubras al final que esa zona no entra en delivery.';
    setWizardMode('locked');
  }

  function applyLockedCheckoutState() {
    if (!continueBtn) return;
    if (wizardMode === 'browse_only' && currentStep === totalSteps - 1) {
      continueBtn.disabled = true;
      continueBtn.textContent = 'SIN COBERTURA PARA ESTA DIRECCIÓN';
    }
  }

  function openUpsellModal() {
    if (!upsellModal) {
      submitToCart();
      return;
    }

    lastFocusedElement = document.activeElement;
    upsellModal.hidden = false;
    document.body.classList.add('wizard-modal-open');

    var title = upsellModal.querySelector('#wizard-upsell-title');
    var copy = upsellModal.querySelector('.wizard-modal__copy');
    var extraCount = getSelectedExtraCount();

    if (title && copy) {
      if (extraCount > 0) {
        title.textContent = '¿Quieres sumar algo más antes de pagar?';
        copy.textContent = 'Ya llevas extras en el pedido. Si quieres, añade otra bebida o un postre y luego sigue al checkout.';
      } else {
        title.textContent = '¿Te falta algo para rematar el pedido?';
        copy.textContent = 'Puedes añadir una bebida o un postre ahora y luego seguir directo al checkout.';
      }
    }

    var confirmBtn = upsellModal.querySelector('[data-wizard-upsell-confirm]');
    if (confirmBtn) confirmBtn.focus();
  }

  function closeUpsellModal() {
    if (!upsellModal || upsellModal.hidden) return;
    upsellModal.hidden = true;
    document.body.classList.remove('wizard-modal-open');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function jumpToExtras(category) {
    closeUpsellModal();
    currentStep = 2;
    updateUI();

    var target = wizard.querySelector('[data-extra-category="' + category + '"]');
    if (target) {
      window.requestAnimationFrame(function() {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  function updateUI() {
    // Update steps visibility
    steps.forEach(function(step, i) {
      step.classList.toggle('active', i === currentStep);
    });

    // Update progress dots
    dots.forEach(function(dot, i) {
      dot.classList.remove('active', 'completed');
      if (i === currentStep) {
        dot.classList.add('active');
      } else if (i < currentStep) {
        dot.classList.add('completed');
        dot.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
      }
      if (i >= currentStep) {
        dot.textContent = i + 1;
      }
    });

    // Update progress lines
    lines.forEach(function(line, i) {
      line.classList.toggle('active', i < currentStep);
    });

    // Update step 2 title based on selected base
    if (step2Title && step2Subtitle) {
      if (selectedBase && selectedBase.isCustom) {
        step2Title.innerHTML = 'ELIGE TUS <span class="text-primary">TOPPINGS</span>';
        step2Subtitle.textContent = 'Personaliza tu papasada a tu gusto';
      } else {
        step2Title.innerHTML = '¿LE ANADIMOS <span class="text-primary">ALGO MAS?</span>';
        step2Subtitle.textContent = 'Tu papasada ya viene lista. Aqui puedes sumarle extras si te apetece.';
      }
    }

    if (step2BaseSummary && step2BaseSummaryTitle && step2BaseSummaryDescription) {
      if (selectedBase && !selectedBase.isCustom) {
        step2BaseSummary.hidden = false;
        step2BaseSummaryTitle.textContent = selectedBase.name;
        step2BaseSummaryDescription.textContent = selectedBase.description || 'Tu papasada ya viene montada. Si quieres, puedes anadirle algun extra antes de seguir.';
      } else {
        step2BaseSummary.hidden = true;
      }
    }

    // Update total
    if (totalEl) totalEl.textContent = formatMoney(getTotal());

    // Update continue button
    if (continueBtn) {
      if (currentStep === 0) {
        if (!selectedBase) {
          continueBtn.disabled = true;
          continueBtn.textContent = 'SELECCIONA UNA BASE';
        } else {
          continueBtn.disabled = false;
          continueBtn.textContent = 'CONTINUAR';
        }
      } else if (currentStep === 1) {
        // If custom base, require at least 1 topping
        if (selectedBase && selectedBase.isCustom && !hasToppingsSelected()) {
          continueBtn.disabled = true;
          continueBtn.textContent = 'ELIGE AL MENOS 1 TOPPING';
        } else {
          continueBtn.disabled = false;
          continueBtn.textContent = 'CONTINUAR';
        }
      } else if (currentStep === totalSteps - 1) {
        continueBtn.disabled = false;
        continueBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:6px;vertical-align:middle;"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>PAGAR AHORA';
      } else {
        continueBtn.disabled = false;
        continueBtn.textContent = 'CONTINUAR';
      }
    }

    applyLockedCheckoutState();

    // Show/hide back button
    if (backBtn) {
      backBtn.style.display = currentStep === 0 ? 'none' : '';
    }

    // Build summary if on last step
    if (currentStep === totalSteps - 1 && summaryContainer) {
      buildSummary();
    }
  }

  function buildSummary() {
    var html = '';

    // Base
    if (selectedBase) {
      html += '<div class="wizard__summary-section">';
      html += '<div class="wizard__summary-label">Tu Papasada</div>';
      html += '<div class="wizard__summary-item"><span>' + selectedBase.name + '</span><span>' + formatMoney(selectedBase.price) + '</span></div>';
      html += '</div>';
    }

    // Toppings
    var toppings = [];
    var extras = [];
    Object.keys(selectedItems).forEach(function(id) {
      var item = selectedItems[id];
      if (item.qty > 0) {
        if (item.type === 'topping') toppings.push(item);
        else extras.push(item);
      }
    });

    if (toppings.length > 0) {
      html += '<div class="wizard__summary-section">';
      html += '<div class="wizard__summary-label">' + (selectedBase && selectedBase.isCustom ? 'Toppings' : 'Extras en tu papasada') + '</div>';
      toppings.forEach(function(item) {
        html += '<div class="wizard__summary-item"><span>' + item.name + ' x' + item.qty + '</span><span>+' + formatMoney(item.price * item.qty) + '</span></div>';
      });
      html += '</div>';
    }

    if (extras.length > 0) {
      html += '<div class="wizard__summary-section">';
      html += '<div class="wizard__summary-label">Bebidas & Postres</div>';
      extras.forEach(function(item) {
        html += '<div class="wizard__summary-item"><span>' + item.name + ' x' + item.qty + '</span><span>+' + formatMoney(item.price * item.qty) + '</span></div>';
      });
      html += '</div>';
    }

    // Total
    html += '<div class="wizard__summary-total"><span>TOTAL</span><span>' + formatMoney(getTotal()) + '</span></div>';

    summaryContainer.innerHTML = html;
  }

  function selectBase(card) {
    wizard.querySelectorAll('[data-wizard-base]').forEach(function(c) {
      c.classList.remove('selected');
      c.setAttribute('aria-pressed', 'false');
    });
    card.classList.add('selected');
    card.setAttribute('aria-pressed', 'true');

    selectedBase = {
      variantId: card.getAttribute('data-wizard-base'),
      name: card.getAttribute('data-name'),
      description: card.getAttribute('data-description') || '',
      price: parseInt(card.getAttribute('data-price')) || 0,
      isCustom: card.hasAttribute('data-custom')
    };
    updateUI();
  }

  function preselectBaseFromQuery() {
    var params = new URLSearchParams(window.location.search);
    var requestedHandle = params.get('base');
    if (!requestedHandle) return;

    var matchingCard = wizard.querySelector('[data-wizard-base][data-handle="' + requestedHandle + '"]');
    if (!matchingCard) return;

    selectBase(matchingCard);

    currentStep = 1;

    updateUI();
  }

  function unlockBrowseMode() {
    setWizardMode('browse_only');
    setGateVisibility(false);
    if (experience) experience.hidden = false;
    if (currentStep > totalSteps - 1) currentStep = 0;
    updateUI();
    window.scrollTo({ top: wizard.offsetTop, behavior: 'smooth' });
  }

  function attemptAddressValidation(payload) {
    if (!window.themeCoverage || typeof window.themeCoverage.validateDeliveryAddress !== 'function') {
      setGateResult({ status: 'error', message: 'La validación de cobertura no está disponible ahora mismo.' });
      return;
    }

    addressSubmitBtn.disabled = true;
    addressSubmitBtn.textContent = 'COMPROBANDO...';
    setGateResult({ status: 'locating' });

    window.themeCoverage.validateDeliveryAddress(payload).then(function(state) {
      setGateResult(state || { status: 'error' });
    }).finally(function() {
      addressSubmitBtn.disabled = false;
      addressSubmitBtn.textContent = 'Comprobar cobertura';
    });
  }

  // Base selection
  wizard.querySelectorAll('[data-wizard-base]').forEach(function(card) {
    card.addEventListener('click', function() {
      selectBase(this);
    });

    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectBase(this);
      }
    });
  });

  // Item +/- buttons (event delegation)
  wizard.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wizard-item-add], [data-wizard-item-remove]');
    if (!btn) return;

    var row = btn.closest('[data-wizard-item]');
    if (!row) return;

    var id = row.getAttribute('data-wizard-item');
    var name = row.getAttribute('data-name');
    var price = parseInt(row.getAttribute('data-price')) || 0;
    var type = row.getAttribute('data-type') || 'topping';
    var qtyEl = row.querySelector('[data-wizard-item-qty]');

    if (!selectedItems[id]) {
      selectedItems[id] = { name: name, price: price, qty: 0, type: type, variantId: id };
    }

    if (btn.hasAttribute('data-wizard-item-add')) {
      selectedItems[id].qty++;
    } else if (btn.hasAttribute('data-wizard-item-remove')) {
      if (selectedItems[id].qty > 0) selectedItems[id].qty--;
    }

    if (qtyEl) qtyEl.textContent = selectedItems[id].qty;

    // Highlight row if qty > 0
    if (selectedItems[id].qty > 0) {
      row.classList.add('wizard__item--active');
    } else {
      row.classList.remove('wizard__item--active');
    }

    updateUI();
  });

  // Navigate to next valid step
  function nextStep() {
    if (currentStep < totalSteps - 1) {
      currentStep++;
    }
  }

  // Navigate to previous valid step
  function prevStep() {
    if (currentStep > 0) {
      currentStep--;
    }
  }

  // Continue / Pay button
  if (continueBtn) {
    continueBtn.addEventListener('click', function() {
      if (this.disabled) return;

      if (currentStep < totalSteps - 1) {
        nextStep();
        updateUI();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        if (wizardMode !== 'own_delivery') return;
        openUpsellModal();
      }
    });
  }

  // Back button
  if (backBtn) {
    backBtn.addEventListener('click', function() {
      if (currentStep > 0) {
        prevStep();
        updateUI();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  function submitToCart() {
    if (window.themeCoverage && !window.themeCoverage.guardPurchase()) {
      continueBtn.disabled = false;
      updateUI();
      return;
    }

    // For static items (no real Shopify variant IDs), redirect to cart page
    var isStatic = selectedBase && selectedBase.variantId.indexOf('static') === 0;

    if (isStatic) {
      // Can't add static items to Shopify cart — show message
      alert('Demo: Tu pedido de ' + selectedBase.name + ' por ' + formatMoney(getTotal()) + ' está listo. Crea los productos en Shopify Admin para activar el checkout real.');
      return;
    }

    var items = [];

    if (selectedBase) {
      items.push({
        id: parseInt(selectedBase.variantId),
        quantity: 1,
        properties: buildBaseProperties()
      });
    }

    Object.keys(selectedItems).forEach(function(id) {
      if (selectedItems[id].qty > 0 && !isNaN(parseInt(id))) {
        items.push({
          id: parseInt(id),
          quantity: selectedItems[id].qty,
          properties: {
            '_bundle_base': selectedBase ? selectedBase.name : ''
          }
        });
      }
    });

    if (items.length === 0) return;

    continueBtn.disabled = true;
    continueBtn.textContent = 'PROCESANDO...';

    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      window.location.href = '/checkout';
    })
    .catch(function() {
      continueBtn.disabled = false;
      continueBtn.textContent = 'PAGAR AHORA';
      alert('Error al añadir al carrito. Inténtalo de nuevo.');
    });
  }

  wizard.querySelectorAll('[data-spice]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      selectedSpice = parseInt(this.getAttribute('data-spice'));
      wizard.querySelectorAll('[data-spice]').forEach(function(b, i) {
        b.classList.toggle('is-active', i <= selectedSpice);
      });
      var nameEl = wizard.querySelector('[data-spice-name]');
      if (nameEl) nameEl.textContent = spiceNames[selectedSpice];
    });
  });

  if (upsellModal) {
    upsellModal.addEventListener('click', function(e) {
      if (e.target.closest('[data-wizard-upsell-close]')) {
        closeUpsellModal();
        return;
      }

      var jumpBtn = e.target.closest('[data-wizard-upsell-jump]');
      if (jumpBtn) {
        jumpToExtras(jumpBtn.getAttribute('data-wizard-upsell-jump'));
        return;
      }

      if (e.target.closest('[data-wizard-upsell-confirm]')) {
        closeUpsellModal();
        submitToCart();
      }
    });
  }

  if (addressInput) {
    addressInput.addEventListener('input', function() {
      selectedAddressSuggestion = null;
      var query = this.value.trim();
      if (addressLookupTimer) window.clearTimeout(addressLookupTimer);
      if (query.length < 5 || !window.themeCoverage || typeof window.themeCoverage.searchAddress !== 'function') {
        clearSuggestions();
        return;
      }

      addressLookupTimer = window.setTimeout(function() {
        var postal = postalInput ? postalInput.value.trim() : '';
        var city = cityInput ? cityInput.value.trim() : '';
        var fullQuery = [query, postal, city || 'Barcelona', 'España'].filter(Boolean).join(', ');
        setSuggestionsLoading(true);
        window.themeCoverage.searchAddress(fullQuery).then(function(items) {
          renderSuggestions(items);
        }).catch(function() {
          clearSuggestions();
        }).finally(function() {
          setSuggestionsLoading(false);
        });
      }, 220);
    });
  }

  if (suggestionsEl) {
    suggestionsEl.addEventListener('click', function(e) {
      var option = e.target.closest('[data-wizard-suggestion]');
      if (!option || !suggestionsEl._items) return;

      var selectedIndex = parseInt(option.getAttribute('data-wizard-suggestion'), 10);
      selectedAddressSuggestion = suggestionsEl._items[selectedIndex];
      if (!selectedAddressSuggestion) return;

      if (addressInput) addressInput.value = selectedAddressSuggestion.label;
      if (postalInput && selectedAddressSuggestion.postalCode) postalInput.value = selectedAddressSuggestion.postalCode;
      if (cityInput && selectedAddressSuggestion.city) cityInput.value = selectedAddressSuggestion.city;
      clearSuggestions();
    });
  }

  if (addressForm) {
    addressForm.addEventListener('submit', function(e) {
      e.preventDefault();
      clearSuggestions();

      var payload = {
        address: addressInput ? addressInput.value.trim() : '',
        postalCode: postalInput ? postalInput.value.trim() : '',
        city: cityInput ? cityInput.value.trim() : ''
      };

      if (selectedAddressSuggestion) {
        payload.address = selectedAddressSuggestion.label;
        payload.postalCode = selectedAddressSuggestion.postalCode || payload.postalCode;
        payload.city = selectedAddressSuggestion.city || payload.city;
      }

      attemptAddressValidation(payload);
    });
  }

  if (locateAddressBtn) {
    locateAddressBtn.addEventListener('click', function() {
      if (!window.themeCoverage || typeof window.themeCoverage.locateUser !== 'function') return;
      setGateResult({ status: 'locating' });
      window.themeCoverage.locateUser();
    });
  }

  if (gateActions) {
    gateActions.addEventListener('click', function(e) {
      if (e.target.closest('[data-wizard-gate-proceed]')) {
        setWizardMode('own_delivery');
        setGateVisibility(false);
        if (experience) experience.hidden = false;
        updateUI();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      if (e.target.closest('[data-wizard-gate-browse]')) {
        unlockBrowseMode();
      }
    });
  }

  if (changeAddressBtn) {
    changeAddressBtn.addEventListener('click', function() {
      setGateVisibility(true);
      setWizardMode('locked');
      if (experience) experience.hidden = true;
      window.scrollTo({ top: wizard.offsetTop, behavior: 'smooth' });
      if (addressInput) addressInput.focus();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeUpsellModal();
      clearSuggestions();
    }
  });

  document.addEventListener('papasada:coverage-change', function(event) {
    if (!event.detail) return;
    setGateResult(event.detail);
  });

  // Initialize
  preselectBaseFromQuery();
  setGateResult(getCoverageState());
  if (getCoverageState().status === 'own_delivery') {
    setWizardMode('own_delivery');
    setGateVisibility(false);
  } else {
    setGateVisibility(true);
  }
  updateUI();

})();
